import { StreamActions } from "@hotwired/turbo"

/**
 * Turbo Stream Actions
 * 
 * Extends Turbo's StreamActions with custom actions for frame management.
 * Provides additional functionality beyond the standard Turbo Stream actions.
 * 
 * Custom Actions:
 * - reload: Reloads a Turbo frame
 * - dispatch_event: Dispatches custom events to frames
 * 
 * Usage: These actions can be used in Turbo Stream responses from the server
 */
StreamActions.reload = function() {
  const frame = this.targetElements[0]
  if (frame && frame.reload) {
    frame.reload()
  }
}

// Add a custom dispatch_event action to the StreamActions object
// This is used to dispatch custom events to frames
StreamActions.dispatch_event = function() {
  const frame = this.targetElements[0]
  const eventName = this.templateElement?.innerHTML?.trim()

  if (frame && eventName) {
    frame.dispatchEvent(new Event(eventName, { bubbles: true }))
  }
}